import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="before-after-title" data-id="element-89" data-mp="22l12pb3fr9fc">
      <div className="mx-auto max-w-6xl" data-id="element-90" data-mp="2zb1mevoy6zps">
        <SectionHeading title={<span id="before-after-title" data-id="element-92" data-mp="2z8nvmz1aw9o1">
              From uncertainty when reviewing critical care concepts…{' '}
              <span className="text-brand-dark" data-id="element-93" data-mp="2qa3jyhu5r09b">to a more structured learning process</span>
            </span>} data-id="element-91" data-mp="2z9qm55upoa3f" />
        <div className="mx-auto mt-6 max-w-3xl space-y-4 text-center text-base leading-relaxed text-muted sm:text-lg" data-id="element-94" data-mp="2la7gqktabcut">
          <p data-id="element-95" data-mp="1ewrk0i1ir1sf">
            As a nursing professional, you know that critical care involves much more than memorizing laboratory
            values, monitoring parameters, and clinical terminology.
          </p>
          <p data-id="element-96" data-mp="1765osrsv0gve">
            You need to understand what different measurements represent, recognize their limitations, and consider how
            different findings relate to the broader clinical picture.
          </p>
          <p className="font-semibold text-ink" data-id="element-97" data-mp="y70r1np4grka">
            I created the Critical Care Nursing Blueprint™ to help you organize your educational resources and study
            these concepts through a more structured approach.
          </p>
        </div>

        <div className="mt-12 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-6" data-id="element-98" data-mp="t6cyuyp5q4oh">
          <div className="rounded-3xl bg-danger-soft p-5 ring-1 ring-danger/20 sm:p-8" data-id="element-99" data-mp="ffhlb93pqzek">
            <div className="flex items-center gap-3" data-id="element-100" data-mp="jgtfzt1g2atm">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-danger text-white" data-id="element-101" data-mp="jdffkqcccbot">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="aetxsxep10p3" />
              </span>
              <h3 className="text-2xl font-black uppercase tracking-tight text-danger" data-id="element-103" data-mp="2c40v6oki7k52">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-104" data-mp="27d11ds6oli6s">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-105" data-mp="23bpevvj3td2t">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-106" data-mp="239us0bo9vaw3" />
                  <span className="text-[15px] leading-relaxed text-ink sm:text-base" data-id="element-107" data-mp="1yb1isvg0q61q">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-108" data-mp="2r21ln32m53rt">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-950 text-cta" data-id="element-109" data-mp="2m1dtge2negw0">
              <ArrowDownIcon className="h-6 w-6 lg:hidden" strokeWidth={3} data-id="element-110" data-mp="2h2kkmyyb3e26" />
              <ArrowRightIcon className="hidden h-6 w-6 lg:block" strokeWidth={3} data-id="element-111" data-mp="1anju58s1vo2z" />
            </span>
          </div>

          <div className="rounded-3xl bg-success-soft p-5 ring-1 ring-success/25 sm:p-8" data-id="element-112" data-mp="15nffzpem75fx">
            <div className="flex items-center gap-3" data-id="element-113" data-mp="vlbhb6z2juo4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-success text-white" data-id="element-114" data-mp="10jcy1l90vhwf">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-115" data-mp="15iptgudylxam" />
              </span>
              <h3 className="text-xl font-black uppercase leading-tight tracking-tight text-success sm:text-2xl" data-id="element-116" data-mp="1a9odo522jfj5">
                After — with the Blueprint™
              </h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-117" data-mp="1j9kw3oxv7i5r">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-118" data-mp="1o8xr4wyw3vjf">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-119" data-mp="1o9pb1aj4k4tv" />
                  <span className="text-[15px] font-medium leading-relaxed text-ink sm:text-base" data-id="element-120" data-mp="1t5o8roqcez6y">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-121" data-mp="3v1htar5djk7w">
          My goal is to help you spend less time searching for information and more time studying it in a structured
          way.
        </p>

        <SectionCTA label="I want a more structured approach to critical care nursing" data-id="element-122" data-mp="1yaqcnve1j0qz" />
      </div>
    </section>;
}